import { Button, Dialog, Flex, ScrollArea, Text } from "@radix-ui/themes";

interface TosModalProps {
  open: boolean;
  onAccept: () => void;
}

export default function TosModal({ open, onAccept }: TosModalProps) {
  return (
    <Dialog.Root open={open}>
      <Dialog.Content
        maxWidth="600px"
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <Dialog.Title>Terms of Service — Pilot Program</Dialog.Title>
        <Dialog.Description size="2" mb="3">
          Please read the following terms before continuing.
        </Dialog.Description>
        <ScrollArea type="auto" scrollbars="vertical" style={{ maxHeight: "50vh" }}>
          <Flex direction="column" gap="3" pr="4">
            <Text as="p" size="2">
              Thank you for agreeing to pilot (&ldquo;Pilot&rdquo;) the AMA&rsquo;s AI coaching tool
              (&ldquo;Tool&rdquo;).
            </Text>
            <Text as="p" size="2">
              You are using the Tool, which enables the user to practice coaching, in its early research and
              development phase. Through the Tool, the user coaches a bot who acts as the subject of the
              coaching (&ldquo;Bot&rdquo;). The Bot responds and provides feedback to the coaching you
              provide the Bot through the Tool.
            </Text>
            <Text as="p" size="2">
              AMA may use and incorporate your Feedback in its development of the Tool and other AMA
              activities. You hereby assign to AMA all right, title, and interest in the Feedback (insights,
              critiques, recommendations, suggested changes, or other feedback about the Tool you provide
              AMA regardless of form (verbal, written, otherwise)).
            </Text>
            <Text as="p" size="2">
              AMA MAKES NO WARRANTY WHATSOEVER REGARDING THE TOOL, INCLUDING ANY (a) WARRANTY OF
              MERCHANTABILITY or (b) WARRANTY OF FITNESS FOR A PARTICULAR PURPOSE, WHETHER ARISING BY LAW,
              COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OF TRADE, OR OTHERWISE. AMA SPECIFICALLY
              DISCLAIMS ANY LIABILITY FOR ANY DAMAGES THAT MAY ARISE THROUGH PILOTING THE TOOL, WHICH IS
              &ldquo;AS IS.&rdquo;
            </Text>
            <Text as="p" size="2">
              The Tool is the intellectual property of the AMA. No rights in the Tool are conferred to you
              through this Pilot. The Tool is confidential. You agree to keep the Tool and AMA&rsquo;s
              Confidential Information (non-public information about AMA that would be considered
              confidential to a reasonable person) confidential.
            </Text>
            <Text as="p" size="2">
              AMA&rsquo;s Privacy Policy and Terms of Use apply to your piloting of the Tool.
            </Text>
            <Text as="p" size="2">
              AMA recommends against inputting any personally identifiable information into the Tool.
            </Text>
            <Text as="p" size="2" weight="bold">
              Use of the Tool indicates your acceptance of these terms.
            </Text>
          </Flex>
        </ScrollArea>
        <Flex justify="end" mt="4">
          <Button onClick={onAccept}>Accept</Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
